if (!customElements.get('recent-views')) {
  class RecentViews extends HTMLElement {
    constructor() {
      super();

      this.localStorageName = 'recentViews'; // recentViews
    }

    connectedCallback() {
      const recentViewsHandles = localStorage.getItem(this.localStorageName);

      recentViewsHandles != '' ? this.getRecentViewProducts() : this.handleRecentViewsEmpty();
    }

    async getRecentViewProducts() {
      const wishlistWrapper = this.querySelector('.js-recent-wrapper');

      const recentViews = localStorage.getItem(this.localStorageName)?.split('||').reverse() || [];

      if (!recentViews || !wishlistWrapper || recentViews.length == 0) {
        this.handleRecentViewsEmpty();

        return;
      }

      const resolveHTML = Promise.all(
        recentViews.map(async (productHandle) => {
          if (productHandle.trim() == '') return '';
          const cardName = this.dataset.card || '';
          const response = await fetch(`/products/${productHandle}?view=card${cardName}`);

          if (response.ok) {
            const productCardHTML = await response.text();

            const productCardDOM = this.getSectionDOM(productCardHTML);

            if (productCardDOM)
              return `<div class="${
                this.dataset.productCardClass || 'featured-collection__product swiper-slide'
              }">${productCardDOM.outerHTML}</div>`;
            else return '';
          }
        })
      );

      const recentViewHTMLs = await resolveHTML;

      let recentViewHTML = '';
      recentViewHTMLs.forEach((html) => {
        if (html) recentViewHTML += html;
      });

      wishlistWrapper.innerHTML = recentViewHTML;

      requirejs(['lazyload1'], function() {
        if (window.updateLazyLoad) window.updateLazyLoad();
      })
      
      // if (window.StampedFn) window.StampedFn.reloadUGC();

      wishlistWrapper.classList.remove('is-loading');
    }

    handleRecentViewsEmpty() {
      this.classList.add('hidden');
    }

    getSectionDOM(html, selector = '.js-product-card') {
      const dom = new DOMParser().parseFromString(html, 'text/html');
      if (selector) return dom.querySelector(selector);

      return dom;
    }
  }

  customElements.define('recent-views', RecentViews);
}
